import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import TextField from "@plugins/text-field/text-field";
import VCard from 'vuetify/src/components/VCard';

import Modal from '../modal/modal';

@Component
export default class AddField extends Vue {
  textFieldConfig = {
    height: 42,
    showEditIconOnHover: false,
    box: true,
    showValidationIcons: false
  };
  fieldLabel= '';

  onTextFieldValueChange(name, value) {
    console.log(name, value);
  };
  onCancel(event) {
    this.$emit('cancelled', true);
  };
  onFieldAdd() {
    this.$emit('added', {fieldLabel: this.fieldLabel});
  };

  render(createElement) {
    return (
      <Modal 
        id={'cmp-add-field'}
        onCancelled={this.onCancel}
      >
        <template slot="header"> {this.$t('add')} {this.$t('custom_field')} </template>
        <template slot="body">
          <div class="form-group">
            <TextField
              class="m0"
              id={'fieldLabel'}
              required={true}
              vModel={this.fieldLabel}
              isModel
              placeholder={this.$t('field_label')}
              onValuechanged={this.onTextFieldValueChange}
              {...{attrs: this.textFieldConfig}}
            ></TextField>
          </div>
        </template>

        <template slot="options">
          <button
            class="dt-button v1 with-ico"
            onClick={this.onFieldAdd}
          > 
          <div class="dt-icon-container">
            <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
          </div>
          <div class="button-text">
            {this.$t('add')} {this.$t('Custom Field')}
          </div>
          </button>
          <button 
            class="dt-button s6" 
            onClick={this.onCancel}
          > {this.$t('cancel')} </button>
        </template>
      </Modal>
    );
  }
} 


{/* <v-layout row wrap>
  <v-flex md6>
    <v-layout row wrap justify-start>

    </v-layout>
  </v-flex>
  <v-flex md6>
    <v-layout row wrap justify-end>
      <button
        class="dt-button v1 s1"
        onClick={this.onFieldAdd}
      > {this.$t('add')} {this.$t('new')} {this.$t('custom_field')} </button>
      <button 
        class="dt-button s1" 
        onClick={this.onCancel}
      > {this.$t('cancel')} </button>
    </v-layout>
  </v-flex>
</v-layout> */}